import { render, staticRenderFns } from "./forgotPassWord.vue?vue&type=template&id=4615de3c&"
import script from "./forgotPassWord.vue?vue&type=script&lang=js&"
export * from "./forgotPassWord.vue?vue&type=script&lang=js&"
import style0 from "./forgotPassWord.vue?vue&type=style&index=0&id=4615de3c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports